import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { Modal } from "reactstrap";
import { RootState } from "../../store";
import styles from "./Spinner.module.scss";

const Spinner: React.FC = () => {
  const pendingRequetsNbr = useSelector((state: RootState) => state.spinner.pendingRequests);
  const onSpinnerModalClosed = () => {
    document?.querySelector("body")?.classList.remove("modal-open");
  };
  const spinnerModal = (
    <Modal cssModule={styles} isOpen={pendingRequetsNbr > 0} onClosed={onSpinnerModalClosed}>
      <div className="loader-box">
        <div className="loader-19"></div>
      </div>
    </Modal>
  );
  return ReactDOM.createPortal(spinnerModal, document?.getElementById("spinner-root")!);
};
export default Spinner;
